'use client';

const liveAreaLabel = "Already announced live-messages";
export {
  liveAreaLabel
};
